<template>
    <div class="content-item" @click="clickCampaign()">
        <div class="content-item-img">
            <img :src="campaign.fullImageUrl" />
        </div>
        <div class="content-item-detail">
            <div class="item-detail-header">{{ campaign.name }}</div>
            <div class="item-detail-body">{{ pointText }}</div>
        </div>
    </div>
</template>
<script>
// mixin
import LocaleMixin from "@/mixin/LocaleMixin";

export default {
    name: "CampaignListItem",
    props: {
        campaign: Object
    },
    mixins: [LocaleMixin],
    computed: {
        pointText: function() {
            var txtUse = this.lbl.campaign.use_point;
            var txtGet = this.lbl.campaign.get_point;
            var startText = this.campaign.pointType == "get" ? txtGet : txtUse;
            return `${startText} ${this.campaign.pointPerUnit}`;
        }
    },
    methods: {
        clickCampaign: function() {
            this.$emit("clickCampaign", this.campaign);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/baseImage.scss";
@import "@/style/base/baseText.scss";
.content-item {
    border: 1px solid #cdcdcd;
    border-radius: 5px;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    .content-item-img {
        @include baseRatioImg(50%);
        flex: 0 0 100%;
        // flex: 0 0 35%;
        img {
            border: 0px;
            border-radius: 5px;
        }
    }
    .content-item-detail {
        flex: 0 0 100%;
        padding: 5px 10px;
        // flex: 0 0 65%;
        .item-detail-header {
            @extend %ellipsis-2;
            font-weight: bold;
            line-height: 15px;
        }
        .item-detail-body {
            margin-top: 5px;
        }
    }
}
</style>
